export const contractManagementRouter = [
  {
    path: "/signatures/contract-management/list",
    name: "signatures-contract-management",
    meta: { title: "合同管理" },
    component: () => import("@/views/signatures/contract-management/list/index.vue"),
  },
];
